export function deepMerge(target, source) {
    const merged = { ...target };
    for (const key in source) {
        const k = key;
        const val = source[k];
        if (typeof val === "object" && val !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            merged[k] = deepMerge(merged[k], val);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            merged[k] = source[k];
        }
    }
    return merged;
}
